import { useState, FormEvent } from 'react';

export default function SubscribeSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    setStatus('sending');
    const data = new URLSearchParams();
    data.append('email', email);
    try {
      const res = await fetch('https://readdy.ai/api/form/d71o64c991ove783t3dg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      if (res.ok) {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section className="py-6 sm:py-8 bg-[#f5f0eb]">
      <div className="max-w-5xl mx-auto px-5 sm:px-8">
        <form onSubmit={handleSubmit} data-readdy-form id="subscribe-form">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <div className="flex-1">
              <h6 className="text-base font-semibold text-gray-800 mb-1">Subscribe News</h6>
              <p className="text-sm text-gray-600">
                Signup for our newsletter to get the latest news, updates and amazing offers delivered directly in your inbox.
              </p>
            </div>
            <div className="flex gap-2 w-full sm:w-auto">
              <input
                type="email"
                name="email"
                required
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="Email Address"
                className="border border-gray-300 rounded px-4 py-2 text-sm flex-1 sm:min-w-[200px] md:min-w-[240px] focus:outline-none focus:border-gray-500 bg-white"
              />
              <button
                type="submit"
                disabled={status === 'sending'}
                className="bg-gray-800 text-white px-4 sm:px-6 py-2 text-sm tracking-wide hover:bg-gray-700 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60"
              >
                {status === 'sending' ? 'Subscribing...' : 'Subscribe'}
              </button>
            </div>
          </div>
          {status === 'success' && (
            <p className="mt-3 text-green-600 text-sm">Successfully subscribed! Thank you.</p>
          )}
          {status === 'error' && (
            <p className="mt-3 text-red-600 text-sm">Something went wrong. Please try again.</p>
          )}
        </form>
      </div>
    </section>
  );
}
